import { Box } from '@mui/material';

export default function Logo({ sx }) {
  return (
    <Box sx={{ ...sx }}>
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" />
    </Box>
  );
}
